/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaRowStatiIndexRange from './AqaRowStatiIndexRange';

/**
 * The AqaBulkRowStatiRequest model module.
 * @module model/AqaBulkRowStatiRequest
 * @version v0
 */
export default class AqaBulkRowStatiRequest {
  /**
   * Constructs a new <code>AqaBulkRowStatiRequest</code>.
   * @alias module:model/AqaBulkRowStatiRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaBulkRowStatiRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaBulkRowStatiRequest} obj Optional instance to populate.
   * @return {module:model/AqaBulkRowStatiRequest} The populated <code>AqaBulkRowStatiRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaBulkRowStatiRequest();
      if (data.hasOwnProperty('listOfIndividualRowIndices'))
        obj.listOfIndividualRowIndices = ApiClient.convertToType(data['listOfIndividualRowIndices'], ['Number']);
      if (data.hasOwnProperty('ranges'))
        obj.ranges = ApiClient.convertToType(data['ranges'], [AqaRowStatiIndexRange]);
      if (data.hasOwnProperty('newValue'))
        obj.newValue = ApiClient.convertToType(data['newValue'], 'Blob');
    }
    return obj;
  }
}

/**
 * @member {Array.<Number>} listOfIndividualRowIndices
 */
AqaBulkRowStatiRequest.prototype.listOfIndividualRowIndices = undefined;

/**
 * @member {Array.<module:model/AqaRowStatiIndexRange>} ranges
 */
AqaBulkRowStatiRequest.prototype.ranges = undefined;

/**
 * @member {Blob} newValue
 */
AqaBulkRowStatiRequest.prototype.newValue = undefined;

